// @import dependencies
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import React, { CSSProperties } from 'react'
import { FieldValues, UseFormMethods } from 'react-hook-form';
// @end dependencies

// @import components
import { Modal } from 'react-bootstrap';
import AttachedModule from '../AttachedModule/AttachedModule';
// @end components

// @import types
import * as AttachedCategoryTypes from 'app_types/admin/attachedCategory/attachedCategory.types';
import * as AttachedTypes from 'app_types/admin/attached/attached.types';
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalAttached.scss'
import { AiOutlineCloseCircle } from 'react-icons/ai';
// @end styles

interface IModalAttachedProps {
  open: boolean
  category?: AttachedCategoryTypes.TypeAttachedCategories
  categoryId?: string
  title?: string
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  formHook?: UseFormMethods<FieldValues>
  name?: string
  required?: boolean
  defaultValue?: string | AttachedTypes.IAttached  // Id del attached
  disabled?: boolean
  observations?: string
  preSaveMessage?: string
  disableCloseAfterSave?: boolean
  onClose?: ()=>any
  onFileSaved?: (attached: AttachedTypes.IAttached) => void
}

const ModalAttached: React.FC<IModalAttachedProps> = (props) => {

  /**
   * @INFO Click en cerrar
   */
   const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }

  const handleFileSaved = (attached: AttachedTypes.IAttached) => {
    if (props.onFileSaved) {
      props.onFileSaved(attached);
    }
    if (!props.disableCloseAfterSave) {
      handleClickClose();
    }
  }

  return(
    <Modal
      className={`modal-learning-path-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_attached-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <AiOutlineCloseCircle
            className='close-icon'
            onClick={handleClickClose}
          />
          {props.title ?
            <TextComponent
              type='subtitle'
            >
              {props.title}
            </TextComponent>
          :null}
          {props.observations ?
            <div>
              <TextComponent
                type='text'
                style={{fontWeight: 700}}
              >
                Observaciones:
              </TextComponent>
              <TextComponent
                type='text'
              >
                {props.observations}
              </TextComponent>
            </div>
          :null}
          <AttachedModule
            onFileSaved={handleFileSaved}
            formHook={props.formHook}
            name={props.name}
            defaultValue={props.defaultValue}
            required={props.required}
            category={props.category}
            categoryId={props.categoryId}
            disabled={props.disabled}
            preSaveMessage={props.preSaveMessage}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalAttached;
